import { Component } from '@angular/core';
import { AppSessionStorageService } from 'src/app/services/utils/session-storage.service';

@Component({
  selector: 'app-user-exist',
  templateUrl: './user-exist.component.html',
  styleUrl: './user-exist.component.css'
})
export class UserExistComponent {
  appRedirectionLink = AppSessionStorageService.appRedirctionLink

}
